export const DASHBOARD_VALUES = [
  { label: 'HR Admin Dashboard', value: 'hr_admin' },
  { label: 'Reporting Manager Dashboard', value: 'reporting_manager' },
  { label: 'Employee Dashboard', value: 'employee' },
  { label: 'Recruiter Manager Dashboard', value: 'recruitment_manager' },
  { label: 'Recruiter Dashboard', value: 'recruiter' }
];

export const DASHBOARD_TEMPLATES = {
  employee: {
    title: 'Welcome John!',
    showNotifictionRedirection: true,
    notificationRedirectionTypes: ['Exit', 'Leave Management', 'Attendance', 'ProjectTimesheet'],
    layoutData: [
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "onboarding_checklist_tile",
              title: "Onboarding Checklist"
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "summary_tile",
              // type: "coming_soon",
              title: "Employee Check-in Summary",
              footerLink: "View Attendance Summary",
              apiValue: 'employeeDashboard'
            }
          },
          // {
          //   type: "column",
          //   size: 4,
          //   content: {
          //     type: "announcement_tile",
          //     // type: "coming_soon",
          //     title: "Announcements",
          //     footerLink: "List of Announcement"
          //   }
          // },
          {
            type: "column",
            size: 4,
            customClass: 'fb-d-col-flex',
            children: [
              {
                type: "row",
                customClass: 'fb-content-row-height',
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "attendence_details"
                    }
                  }
                ]
              },
              {
                type: "row",
                customClass: 'fb-rest-height',
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      // type: "coming_soon",
                      type: "notification_tile",
                      title: "Notifications",
                      noOfRows: 1
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Employee Leave Status",
              footerLink: "View Employee Leave Status",
              apiValue: "employeeLeaveStatus"
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "holiday_list_tile",
              title: "Holiday List",
              footerLink: "View All"
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "team_members_tile",
              title: "My Team(0)",
              footerLink: "List of Team Members"
            }
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Leave Balance",
              // subTitle: "Upcoming Leave - 25 May 2023",
              footerLink: "List view of leave taken & balance",
              apiValue: "leaveBalance"
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              // type: "coming_soon",
              title: "Timesheet Summary",
              footerLink: "View Employee List",
              apiValue: 'timeSheetSummary'
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              //type: "announcement_tile",
              type: "coming_soon",
              title: "Announcements",
              footerLink: "List of Announcement"
            }
          }
          // {
          //   type: "column",
          //   size: 4,
          //   content: {
          //     type: "holiday_list_tile",
          //     title: "Holiday List",
          //     footerLink: "View All"
          //   }
          // }
        ]
      }
    ]
  },
  reporting_manager: {
    title: 'My Dashboard - Reporting Manager',
    showNotifictionRedirection: true,
    notificationRedirectionTypes: ['Exit', 'Leave Management', 'Attendance', 'ProjectTimesheet', 'Leave Management RM APPR', 'Leave Management RM Reject'],
    layoutData: [
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 3,
            content: {
              type: "small_tile",
              title: "No. of Employees",
              bgcolor: "#D2EFF3",
              apiValue: "employee"
            }
          },
          {
            type: "column",
            size: 3,
            content: {
              type: "small_tile",
              title: "Employees on Leave",
              bgcolor: "#FEF4F6",
              apiValue: "STAFFONEAVE"
            }
          },
          {
            type: "column",
            size: 3,
            content: {
              type: "small_tile",
              title: "Attendance not Recorded",
              bgcolor: "#FEF8E8",
              apiValue: "ATTENDANCENOTRECORDED/{date-YYYY-MM-DD}"
            }
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 8,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "leave_approval_tile",
                      title: "Leave Approvals",
                      footerLink: "View All"
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      title: "Employee Status",
                      footerLink: "View Employee List",
                      apiValue: "EMPLOYEE"
                      //footerLink: "View Employee List",
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      // type: "coming_soon",
                      title: "Employee Check-in Summary",
                      footerLink: "View Attendance Summary",
                      apiValue: 'reportingManagerDashboard'
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      title: "Onboarding Summary",
                      //footerLink: "View Employee List",
                      employeeList: true,
                      apiValue: 'dashboard/onboarding'
                    }
                  }
                ]
              }
            ]
          },
          {
            type: "column",
            size: 4,
            customClass: 'fb-d-col-flex',
            children: [
              {
                type: "row",
                customClass: 'fb-content-row-height',
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "attendence_details"
                    }
                  }
                ]
              },
              {
                type: "row",
                customClass: 'fb-rest-height',
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      // type: "coming_soon",
                      type: "notification_tile",
                      title: "Notifications",
                      noOfRows: 2
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 8,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      title: "Employee Exit Summary",
                      //footerLink: "View Employee List",
                      apiValue: 'dashboard/employee/exit'
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "table_tile",
                      // type: "coming_soon",
                      title: "Timesheet Summary",
                      //footerLink: "View Employee List",
                      apiValue: 'timeSheetSummary'
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "holiday_list_tile",
                      title: "Holiday List",
                      footerLink: "View All"
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      //type: "announcement_tile",
                       type: "coming_soon",
                      title: "Announcements",
                      footerLink: "List of Announcement"
                    }
                  }
                ]
              }
            ]
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "team_members_tile",
              title: "Team Members",
              footerLink: "View All"
            }
          }
        ]
      }
    ]
  },
  hr_admin: {
    title: 'My Dashboard - HR Admin',
    showNotifictionRedirection: true,
    notificationRedirectionTypes: ['Exit', 'Leave Management', 'Attendance', 'ProjectTimesheet', 'Leave Management HR APPR', 'Leave Management RM Reject'],
    layoutData: [
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 3,
            content: {
              type: "small_tile",
              title: "No. of Employees",
              bgcolor: "#D2EFF3",
              apiValue: "EMPLOYEE"
            }
          },
          {
            type: "column",
            size: 3,
            content: {
              type: "small_tile",
              title: "Employees on Leave",
              bgcolor: "#FEF4F6",
              apiValue: "STAFFONEAVE"
            }
          },
          {
            type: "column",
            size: 3,
            content: {
              type: "small_tile",
              title: "Attendance not Recorded",
              bgcolor: "#FEF8E8",
              apiValue: "ATTENDANCENOTRECORDED/{date-YYYY-MM-DD}"
            }
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 8,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "leave_approval_tile",
                      title: "Leave Approvals",
                      footerLink: "View All"
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      title: "Employee Status",
                      footerLink: "View Employee List",
                      apiValue: "EMPLOYEE"
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      // type: "coming_soon",
                      title: "Employee Check-in Summary",
                      footerLink: "View Attendance Summary",
                      apiValue: 'HRMANAGERDASHBOARD'
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      title: "Onboarding Summary",
                      footerLink: "View Employee List",
                      employeeList: true,
                      apiValue: 'dashboard/onboarding'
                    }
                  }
                ]
              }
            ]
          },
          {
            type: "column",
            size: 4,
            customClass: 'fb-d-col-flex',
            children: [
              {
                type: "row",
                customClass: 'fb-content-row-height',
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "attendence_details"
                    }
                  }
                ]
              },
              {
                type: "row",
                customClass: 'fb-rest-height',
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      // type: "coming_soon",
                      type: "notification_tile",
                      title: "Notifications",
                      noOfRows: 2
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 8,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "summary_tile",
                      title: "Employee Exit Summary",
                      footerLink: "View Employee List",
                      apiValue: 'dashboard/employee/exit'
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "table_tile",
                      // type: "coming_soon",
                      title: "Timesheet Summary",
                      footerLink: "View Employee List",
                      apiValue: 'timeSheetSummary'
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "holiday_list_tile",
                      title: "Holiday List",
                      footerLink: "View All"
                    }
                  },
                  {
                    type: "column",
                    size: 6,
                    content: {
                      type: "coming_soon",
                      // type: "coming_soon",
                      title: "Announcements",
                      footerLink: "List of Announcement"
                    }
                  }
                ]
              }
            ]
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "team_members_tile",
              title: "Team Members",
              footerLink: "View All"
            }
          }
        ]
      }
    ]
  },
  recruitment_manager: {
    title: 'My Dashboard',
    showNotifictionRedirection: true,
    notificationRedirectionTypes: ['TA Requisition', 'Applicant Reminder', 'TANewApplicant', 'TA Interview Reminder', 'TA Postposition'],
    layoutData: [
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 8,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Requests",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfRequests",
                      valueColor: "#027EC0",
                      borderRadius: "4px"
                    }
                  },
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Submissions",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfSubmissions",
                      valueColor: "#10AA03",
                      borderRadius: "4px"
                    }
                  },
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Interviews",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfInterViews",
                      valueColor: "#F36C24",
                      borderRadius: "4px"
                    }
                  },
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Placements",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfPlacements",
                      valueColor: "#013393",
                      borderRadius: "4px"
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "table_tile",
                      title: "Job Openings",
                      footerLink: "Show More",
                      apiValue: "jobOpenings",
                      // headerRedirectButton: [{
                      //   name: 'Create Submissions',
                      //   pageFormId: 187
                      // }],
                      tableScrollableHeight: 340,
                      minTableHeight: 382,
                      tableClass: 'p-fbtable-striped p-fbtable-gridlines'
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "table_tile",
                      title: "Activity Report",
                      footerLink: "Show More",
                      apiValue: "activityreport",
                      headerFilters: [{
                        filterType: 'Year',
                        apiFilterParamName: 'year',
                        apiOrder: 1,
                        apiVarible: '$year',
                        numberOfPastYears: 20,
                        numberOfFutureYears: 5
                      }, {
                        filterType: 'Month',
                        apiFilterParamName: 'month',
                        apiOrder: 0,
                        apiVarible: '$month'
                      }],
                      tableScrollableHeight: 168,
                      minTableHeight: 222,
                      tableClass: 'p-fbtable-striped p-fbtable-gridlines'
                    }
                  }
                ]
              }
            ]
          },
          {
            type: "column",
            size: 4,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "quick_access",
                      title: "Quick Access",
                      redirectionDetails: {
                        CreateReq: 187,
                        PostJob: 209,
                        InterviewProcess: 277
                      }
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "notification_tile",
                      title: "Notifications",
                      noOfRows: 2,
                      cardHeight: 695
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Turn Around Time (TAT)",
              footerLink: "View All",
              apiValue: "turnAroundTime",
              headerFilters: [{
                filterType: 'Year',
                apiFilterParamName: 'year',
                apiOrder: 1,
                apiVarible: '$year',
                numberOfPastYears: 20,
                numberOfFutureYears: 5
              }, {
                filterType: 'Month',
                apiFilterParamName: 'month',
                apiOrder: 0,
                apiVarible: '$month'
              }],
              tableScrollableHeight: 168,
              minTableHeight: 210,
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Turnaround Time and Fill Ratio",
              apiValue: "tATAndFillRatio/jobs",
              headerFilters: [{
                filterType: 'APIValues',
                apiOrder: 0,
                api: '/vd/formBuilder/dashboard/jobPositions',
                multiSelect: true,
                filterWidth: 210,
                itemsLabel: 'position'
              }],
              tableScrollableHeight: 168,
              minTableHeight: 210,
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              apiType: 'post',
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "chart_tile",
              title: "My Margin Growth",
              apiValue: "myMarginGrowth",
              chartHeight: 268,
              showYAxisLabel: false,
              headerFilters: [{
                filterType: 'referenceLibrary',
                apiFilterParamName: 'filter',
                apiOrder: 0,
                apiVarible: '$filter-reference',
                referenceLibraryCategoryName: 'FBMARGINGROWTH',
                filterWidth: 140
              }]
            }
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Interview Status",
              apiValue: "interviewStatus",
              headerFilters: [{
                filterType: 'Outcome',
                apiFilterParamName: 'outcome',
                apiOrder: 0,
                apiVarible: '$outcome',
              },
              {
                filterType: 'Year',
                apiFilterParamName: 'year',
                apiOrder: 2,
                apiVarible: '$year',
                numberOfPastYears: 20,
                numberOfFutureYears: 5
              }, {
                filterType: 'Month',
                apiFilterParamName: 'month',
                apiOrder: 1,
                apiVarible: '$month'
              }],
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              tableScrollableHeight: 168,
              moveControlsToNextLine: true
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Onboarding / Dropouts",
              apiValue: null,
              headerFilters: [{
                filterType: 'APIValues',
                apiOrder: 0,
                api: '/vd/formBuilder/dashboard/jobPositions',
                multiSelect: true,
                filterWidth: 210,
                itemsLabel: 'position'
              }],
              tableScrollableHeight: 218,
              minTableHeight: 258,
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              apiType: 'post'
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Resume Source",
              apiValue: "resumeSource",
              headerFilters: [{
                filterType: 'referenceLibrary',
                apiFilterParamName: 'days',
                apiOrder: 0,
                apiVarible: '$days-reference',
                referenceLibraryCategoryName: 'FBDASHBOARDDURATION'
              }],
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              tableScrollableHeight: 198,
              minTableHeight: 238
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "chart_tile",
              title: "Recruiter's Efficiency",
              apiValue: "recruiterefficiency",
              showYAxisLabel: true,
              headerFilters: [{
                filterType: 'Year',
                apiFilterParamName: 'year',
                apiOrder: 1,
                apiVarible: '$year',
                numberOfPastYears: 20,
                numberOfFutureYears: 5
              }, {
                filterType: 'Month',
                apiFilterParamName: 'month',
                apiOrder: 0,
                apiVarible: '$month'
              }],
              chartHeight: 347,
              moveControlsToNextLine: true
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Top 5 Recent Submissions",
              apiValue: "recentSubmissions",
              tableScrollableHeight: 318,
              minTableHeight: 370,
              tableClass: 'p-fbtable-striped p-fbtable-gridlines'
            }
          }
        ]
      }
    ]
  },
  recruiter: {
    title: 'My Dashboard',
    showNotifictionRedirection: true,
    notificationRedirectionTypes: ['TA Requisition', 'Applicant Reminder', 'TANewApplicant', 'TA Interview Reminder', 'TA Postposition'],
    layoutData: [
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 8,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Requests",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfRequests",
                      valueColor: "#027EC0",
                      borderRadius: "4px"
                    }
                  },
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Submissions",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfSubmissions",
                      valueColor: "#10AA03",
                      borderRadius: "4px"
                    }
                  },
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Interviews",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfInterViews",
                      valueColor: "#F36C24",
                      borderRadius: "4px"
                    }
                  },
                  {
                    type: "column",
                    size: 3,
                    content: {
                      type: "small_tile",
                      title: "Number of Placements",
                      bgcolor: "#FBFBFB",
                      apiValue: "dashboard/numberOfPlacements",
                      valueColor: "#013393",
                      borderRadius: "4px"
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "table_tile",
                      title: "Job Openings",
                      footerLink: "Show More",
                      apiValue: "jobOpenings",
                      // headerRedirectButton: [{
                      //   name: 'Create Submissions',
                      //   pageFormId: 187
                      // }],
                      tableScrollableHeight: 402,
                      minTableHeight: 444,
                      tableClass: 'p-fbtable-striped p-fbtable-gridlines'
                    }
                  }
                ]
              }
            ]
          },
          {
            type: "column",
            size: 4,
            children: [
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "quick_access",
                      title: "Quick Access",
                      redirectionDetails: {
                        CreateReq: 187,
                        PostJob: 209,
                        InterviewProcess: 277
                      }
                    }
                  }
                ]
              },
              {
                type: "row",
                children: [
                  {
                    type: "column",
                    size: 12,
                    content: {
                      type: "notification_tile",
                      title: "Notifications",
                      noOfRows: 2,
                      cardHeight: 399
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "row",
            children: [
              {
                type: "column",
                size: 8,
                content: {
                  type: "table_tile",
                  title: "Activity Report",
                  footerLink: "Show More",
                  apiValue: "activityreport",
                  headerFilters: [{
                    filterType: 'Year',
                    apiFilterParamName: 'year',
                    apiOrder: 1,
                    apiVarible: '$year',
                    numberOfPastYears: 20,
                    numberOfFutureYears: 5
                  }, {
                    filterType: 'Month',
                    apiFilterParamName: 'month',
                    apiOrder: 0,
                    apiVarible: '$month'
                  }],
                  tableScrollableHeight: 168,
                  minTableHeight: 210,
                  tableClass: 'p-fbtable-striped p-fbtable-gridlines'
                }
              },
              {
                type: "column",
                size: 4,
                content: {
                  type: "chart_tile",
                  title: "My Margin Growth",
                  apiValue: "myMarginGrowth",
                  chartHeight: 268,
                  showYAxisLabel: false,
                  headerFilters: [{
                    filterType: 'referenceLibrary',
                    apiFilterParamName: 'filter',
                    apiOrder: 0,
                    apiVarible: '$filter-reference',
                    referenceLibraryCategoryName: 'FBMARGINGROWTH',
                    filterWidth: 140
                  }]
                }
              }
            ]
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "row",
            children: [
              {
                type: "column",
                size: 8,
                content: {
                  type: "table_tile",
                  title: "Quick Interview Scheduling",
                  apiValue: "quickInterviewSceduling",
                  tableClass: 'p-fbtable-striped p-fbtable-gridlines',
                  tableScrollableHeight: 248,
                  minTableHeight: 290,
                  globalsearch: true
                  // showMore: {
                  //   itemsShownOnLoad: 6
                  // }
                }
              },
              {
                type: "column",
                size: 4,
                content: {
                  type: "table_tile",
                  title: "Top 5 Recent Submissions",
                  apiValue: "recentSubmissions",
                  tableScrollableHeight: 235,
                  minTableHeight: 289,
                  tableClass: 'p-fbtable-striped p-fbtable-gridlines'
                }
              }
            ]
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Turn Around Time (TAT)",
              footerLink: "View All",
              apiValue: "turnAroundTime",
              headerFilters: [{
                filterType: 'Year',
                apiFilterParamName: 'year',
                apiOrder: 1,
                apiVarible: '$year',
                numberOfPastYears: 20,
                numberOfFutureYears: 5
              }, {
                filterType: 'Month',
                apiFilterParamName: 'month',
                apiOrder: 0,
                apiVarible: '$month'
              }],
              tableScrollableHeight: 200,
              minTableHeight: 242,
              tableClass: 'p-fbtable-striped p-fbtable-gridlines'
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Turnaround Time and Fill Ratio",
              apiValue: "tATAndFillRatio/jobs",
              headerFilters: [{
                filterType: 'APIValues',
                apiOrder: 0,
                api: '/vd/formBuilder/dashboard/jobPositions',
                multiSelect: true,
                filterWidth: 210,
                itemsLabel: 'position'
              }],
              tableScrollableHeight: 199,
              minTableHeight: 240,
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              apiType: 'post',
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Interview Status",
              apiValue: "interviewStatus",
              headerFilters: [{
                filterType: 'Outcome',
                apiFilterParamName: 'outcome',
                apiOrder: 0,
                apiVarible: '$outcome',
              },
              {
                filterType: 'Year',
                apiFilterParamName: 'year',
                apiOrder: 2,
                apiVarible: '$year',
                numberOfPastYears: 20,
                numberOfFutureYears: 5
              }, {
                filterType: 'Month',
                apiFilterParamName: 'month',
                apiOrder: 1,
                apiVarible: '$month'
              }],
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              tableScrollableHeight: 170,
              minTableHeight: 212,
              moveControlsToNextLine: true
            }
          }
        ]
      },
      {
        type: "row",
        children: [
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Resume Source",
              apiValue: "resumeSource",
              headerFilters: [{
                filterType: 'referenceLibrary',
                apiFilterParamName: 'days',
                apiOrder: 0,
                apiVarible: '$days-reference',
                referenceLibraryCategoryName: 'FBDASHBOARDDURATION'
              }],
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              tableScrollableHeight: 299,
              minTableHeight: 337
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "My Candidates",
              apiValue: "mycandidates",
              footerLink: "View All",
              headerFilters: [{
                filterType: 'APIValues',
                apiFilterParamName: 'position',
                apiOrder: 0,
                apiVarible: '$position-reference',
                api: '/vd/formBuilder/dashboard/jobPositions',
                search: true
              }, {
                filterType: 'referenceLibrary',
                apiFilterParamName: 'days',
                apiOrder: 1,
                apiVarible: '$days-reference',
                referenceLibraryCategoryName: 'FBDASHBOARDDURATION'
              }],
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              tableScrollableHeight: 246,
              minTableHeight: 307,
              moveControlsToNextLine: true,
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }
          },
          {
            type: "column",
            size: 4,
            content: {
              type: "table_tile",
              title: "Onboarding Status",
              apiValue: "onboardingStatus",
              // headerFilters: [{
              //   filterType: 'APIValues',
              //   apiFilterParamName: 'position',
              //   apiOrder: 0,
              //   apiVarible: '$position-reference',
              //   api: '/vd/formBuilder/dashboard/jobPositions'
              // }, {
              //   filterType: 'referenceLibrary',
              //   apiFilterParamName: 'days',
              //   apiOrder: 1,
              //   apiVarible: '$days-reference',
              //   referenceLibraryCategoryName: 'FBDASHBOARDDURATION'
              // }],
              tableClass: 'p-fbtable-striped p-fbtable-gridlines',
              tableScrollableHeight: 283,
              minTableHeight: 337,
              moveControlsToNextLine: true,
              // showMore: {
              //   itemsShownOnLoad: 4
              // }
            }


          }
        ]
      }
    ]
  }
};
